module.exports = __webpack_public_path__ + "static/card-2-34f4f80a54399c96486b0aa64fdc6d10.png";